import { render, staticRenderFns } from "./component-customerEditor.vue?vue&type=template&id=7238bdc4&scoped=true&"
import script from "./component-customerEditor.vue?vue&type=script&lang=js&"
export * from "./component-customerEditor.vue?vue&type=script&lang=js&"
import style0 from "./component-customerEditor.vue?vue&type=style&index=0&id=7238bdc4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238bdc4",
  null
  
)

export default component.exports